import { render } from "./ProductChangesSelection.vue?vue&type=template&id=283de079"
import script from "./ProductChangesSelection.vue?vue&type=script&lang=js"
export * from "./ProductChangesSelection.vue?vue&type=script&lang=js"

import "./ProductChangesSelection.vue?vue&type=style&index=0&id=283de079&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__